import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './primitives.css'

/**
 * The "previous page" control in a composed [Pagination](/components/pagination/).
 * A layout wrapper around your own interactive element — provide an `<a>`
 * (e.g. a framework `<Link>`) or a `nord-button` with its own icon, label and
 * navigation, and disable it when there is no previous page.
 *
 * @status draft
 * @category navigation
 * @lightDom true
 *
 * @slot - Default slot for the previous-page link or button.
 */
@customElement('nord-pagination-previous')
export default class PaginationPrevious extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-pagination-previous': PaginationPrevious
  }
}
